// Cancellation Step
export type CancellationEndpoint = 'reason' | 'date' | 'confirm' | 'success';

// Cancellation Reason
export enum CancellationReason {
	VEHICLE_SOLD = 'VEHICLE_SOLD',
	VEHICLE_OFF_ROAD = 'VEHICLE_OFF_ROAD',
	NOT_NEEDED = 'NOT_NEEDED',
	CHEAPER_NO_AP = 'CHEAPER_NO_AP',
}

export type ReasonForCancellation =
	| CancellationReason.VEHICLE_SOLD // I am selling/replacing my vehicle
	| CancellationReason.VEHICLE_OFF_ROAD // My vehicle is off the road (SORN)
	| CancellationReason.NOT_NEEDED // My renewal price is too high
	| CancellationReason.CHEAPER_NO_AP // Finding cheaper insurance elsewhere'
	| ''; // No reason provided / default value

type CancellationReasonContent = {
	[key in CancellationReason]: {
		label: string;
	};
};

export const cancellationReasonContent: CancellationReasonContent = {
	[CancellationReason.VEHICLE_SOLD]: {
		label: 'I am selling/replacing my vehicle',
	},
	[CancellationReason.VEHICLE_OFF_ROAD]: {
		label: 'My vehicle is off the road (SORN)',
	},
	[CancellationReason.NOT_NEEDED]: {
		label: 'My renewal price is too high',
	},
	[CancellationReason.CHEAPER_NO_AP]: {
		label: 'Finding cheaper insurance elsewhere',
	},
};

export type CancellationDateDescription = 'NOW' | 'LATER' | '';

// Cancellation Date
export interface CancellationDate {
	description: CancellationDateDescription;
	date: string;
}
